import { FiChevronRight } from "react-icons/fi";
function BreadCrumb({ links }) {
  return (
    <ul className="breadcrumb_list">
      {links?.map((link, i) => (
        <span key={i}>
          <li className="breadcrumb">{link}</li>
          {i < links.length - 1 && (
            <li className="breadcrumb icon">
              <FiChevronRight />
            </li>
          )}
        </span>
      ))}
    </ul>
  );
}

export default BreadCrumb;
